import * as React from 'react';
const CustomersIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <g
      stroke={props.color || '#FFFFFF8C'}
      strokeLinecap="round"
      strokeOpacity={0.55}
      strokeWidth={1.333}
      opacity={0.7}
    >
      <path d="M8 8a2.667 2.667 0 1 0 0-5.333A2.667 2.667 0 0 0 8 8ZM2.667 13.333c0-2.666 2.4-4.666 5.333-4.666 2.933 0 5.333 2 5.333 4.666" />
    </g>
  </svg>
);
export default CustomersIcon;
